(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-navigation"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    const back = event.target.closest('.aa-mobile-menu-back');
    if (!back || !window.matchMedia('(max-width: 740px)').matches) return;
    const panel = back.closest('.c-accordion__panel');
    const trigger = panel?.previousElementSibling?.querySelector('[data-toggle="accordion"]');
    if (trigger?.getAttribute('aria-expanded') === 'true') {
      trigger.click();
      trigger.focus({ preventScroll: true });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
